import { statuses } from 'keys'
import { done, error, secondary, yellow } from 'styles/theme';

const useStatuses = () => {
    const { inProgress, backToCutting, backToTranscription, backToMarking, uploaded, uploading, brokenFile, created } = statuses

    const customStatus = {
        "undone": {
            label: "לא בוצע",
            bg: "#F4F1BD",
            color: "#AB9603"
        },
        "done": {
            label: "בוצע",
            color: "#4a4c5dff",
            bg: "#c2c6e8"
        },
        "inProgress": {
            label: "בעיבוד",
            color: "#85367cff",
            bg: "#e3cae0ff"
        },
        "completed": {
            label: "הופק דוח",
            color: "#3DA288",
            bg: "#D7F0E2"
        },
        "redo": {
            label: "לביצוע חוזר",
            color: "#FF2618",
            bg: "#FBD9DA"
        },
        "missed": {
            label: "חלף המועד",
            color: "gray"
        },
        "uploading": {
            label: "בהעלאה",
            color: "secondary"
        }
    }

    const mappingByStatus = {
        [inProgress]: {
            ...customStatus.finish
        },
        [backToMarking]: {
            ...customStatus.finish
        },
        [backToCutting]: {
            ...customStatus.finish
        },
        [backToTranscription]: {
            ...customStatus.finish
        },
        [uploaded]: {
            ...customStatus.finish
        },
        ["uploading"]: {
            label: "בהעלאה...",
            border: yellow,
        },
        [created]: {
            label: "לא בוצע",
        },
        ["brokenFile"]: {
            ...customStatus.redo
        },
        ["unComplete"]: {
            ...customStatus.unComplete
        },
        ["part"]: {
            label: "חלקי",
            border: yellow
        },
        ["complete"]: {
            ...customStatus.finish
        },
        ["missed"]: {
            ...customStatus.missed
        }
    }

    return customStatus
}

export default useStatuses